<div class="radio-switch">
  <label
    class="radio-switch__label"
    [ngClass]="{
      'radio-switch__label--selected': isDelivery.value,
    }"
    for="delivery"
  >
    <span>доставкой</span>
  </label>
  <input id="delivery" type="radio" class="radio-switch__input" [formControl]="isDelivery" [value]="true" />

  <label
    class="radio-switch__label"
    [ngClass]="{
      'radio-switch__label--selected': !isDelivery.value,
    }"
    for="pickup"
  >
    <span>самостоятельно</span>
  </label>
  <input id="pickup" type="radio" class="radio-switch__input" [formControl]="isDelivery" [value]="false" />
</div>
